import React from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
} from '@mui/material';

const AboutUs = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Hero Section */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Card sx={{ p: 3 }}>
          <Typography variant="h4" component="h1" color="primary" gutterBottom>
            THE TRUSTED ONLINE MEDICINE PARTNER
          </Typography>
        </Card>
      </Box>

      {/* About Us Section */}
      <Card sx={{ mb: 4 }}>
        <CardHeader title="ABOUT US" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" color="primary" gutterBottom>
                Who we are - India's most convenient online pharmacy
              </Typography>
              <Typography variant="body1">
                Pharma Man is one of India's most trusted pharmacies, dispensing quality medicines at reasonable prices to over 9 million happy customers – PAN India. At Pharma Man, we help you look after your own health effortlessly as well as take care of loved ones wherever they may reside in India. You can buy and send medicines from any corner of the country - with just a few clicks of the mouse.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" color="primary" gutterBottom>
                What we do – Offer fast online access to medicines with convenient home delivery
              </Typography>
              <Typography variant="body1">
                At Pharma Man, we make a wide range of prescription medicines and other health products conveniently available all across India. Even second and third-tier cities and rural villages can now have access to the latest medicines. Since we also offer generic alternatives to most medicines, online buyers can expect significant savings.
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Features Section */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardHeader title="CONVENIENCE" />
            <CardContent>
              <Typography variant="body1">
                Heavy traffic, lack of parking, monsoons, shop closures, forgetfulness... these are some of the reasons that could lead to skipping vital medications. Since taking medicines regularly is a critical component of managing chronic medical conditions, it's best not to run out of essential medicines. Just log on to Pharma Man, place your order online and have your medicines delivered to you – without leaving the comfort of your home.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card>
            <CardHeader title="ONE-STOP SHOP" />
            <CardContent>
              <Typography variant="body1">
                At Pharma Man, we not only provide you with a wide range of medicines listed under various categories, we also offer a wide choice of OTC products including wellness products, vitamins, diet/fitness supplements, herbal products, pain relievers, diabetic care kits, baby/mother care products, beauty care products, and surgical supplies.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card>
            <CardHeader title="TRUST" />
            <CardContent>
              <Typography variant="body1">
                With the highest standards of ethical pharmacy practice, Pharma Man is committed to providing authentic cum affordable medicines as well as a customer service philosophy that is worthy of our valued customers' loyalty. We offer a superior online shopping experience, which includes ease of navigation and absolute transactional security.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1">
          What's more, with easy access to reliable drug information, you get to know all about your medicine at Pharma Man, and once you're a Pharma Man customer, you'll get regular refill reminders, so you'll never again come up short of medicines.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutUs;